export const environment = {
    production: true,
    apiMiddlewareUrlForSuperAdmin: 'https://university.shiningonsafety.us/',
    apiMiddlewareUrl: 'https://university.shiningonsafety.us',
    recaptcha: {
        siteKey: '6Lfir7kpAAAAAHoNUZOI5NGi0O5fXX6c6NKhKGkv',
    },
    squareApplicationId: 'sq0idp-aycFbB-u9AtjKyT8DPOScg', // LIVE
    squareLocationId: 'L680NKX2KGZT5', // LIVE
};